import { render, staticRenderFns } from "./HeraMobileFooter.vue?vue&type=template&id=32d2ca95&scoped=true&"
import script from "./HeraMobileFooter.vue?vue&type=script&lang=js&"
export * from "./HeraMobileFooter.vue?vue&type=script&lang=js&"
import style0 from "./HeraMobileFooter.vue?vue&type=style&index=0&id=32d2ca95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d2ca95",
  null
  
)

export default component.exports